import { createApp } from "vue";
import App from "./App.vue";
import axios from "axios";
import router from "./router";
import store from "@/store";

import "bootstrap/dist/css/bootstrap.css";
//import "@osuecampus/bootstrap-osu/dist/css/bootstrap.css";

import "bootstrap-icons/font/bootstrap-icons.css";
import "@osuecampus/branching-stories/vue/style.css";
import "intro.js/minified/introjs.min.css";

import "@/css/style.css";

import focus from "@/directives/focus";

import CustomAlert from "@/components/ui/CustomAlert.vue";
import { autoAnimatePlugin } from "@formkit/auto-animate/vue";

/* --- Lab Framework --- */
import { createLab } from "@osuecampus/labs-framework/core";
import { LabVuePlugin, createLabService } from "@osuecampus/labs-framework/vue";
import { getExperimentPlugins, initActiveLab } from "@/labRegistry.js";
import { random, randomRange } from "@/helpers/random";

async function bootstrap() {
  await initActiveLab();
  const runtime = createLab({
    plugins: getExperimentPlugins({ random, randomRange })
  });
  const labService = createLabService(runtime);

  const app = createApp(App)
    .use(store)
    .use(router)
    .use(autoAnimatePlugin)
    .use(LabVuePlugin, { labService })
    .directive("focus", focus);
  app.component("CustomAlert", CustomAlert);

  app.config.globalProperties.axios = axios;

  app.mount("#app");
}

bootstrap().catch((err) => {
  console.error("[main] Bootstrap failed", err);
});
